import { createSlice } from "@reduxjs/toolkit"

export const FlagshipStoresSlice = createSlice({
	name: "flagship_stores",
	initialState: {
		flagship_stores: [],
		errors: [],
	},

	reducers: {
		getFlagshipStores: (state, action) => {
            state.flagship_stores = action.payload
            // console.log(action.payload)
		},
		getFlagshipStoresSuccess: (state, action) => {
			state.flagship_stores = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})

// Action creators are generated for each case reducer function
export const {getFlagshipStores, getFlagshipStoresSuccess, getErrors} = FlagshipStoresSlice.actions

export default FlagshipStoresSlice.reducer
